<template>
  <HeaderComponent></HeaderComponent>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import HeaderComponent from '../../../Header/HeaderComponent.vue'
import router from '@/router'
import { useUserStore } from '@/stores/user-auth'
import { doctorAuthStore } from '@/stores/doctor-auth'

export default defineComponent({
  components: {
    HeaderComponent,
  },
  name: 'DocLogoutComponent',

  setup() {
    onMounted(() => {
      const docAuth = doctorAuthStore()
      localStorage.removeItem('docAccessToken')
      docAuth.isAuthenticated = false
      router.push('/')
    })
  },
})
</script>
